import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Jogo da memória", -1)
const _hoisted_2 = { class: "d-flex flex-wrap justify-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Ganhou ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Recomeçar")

import useGameMemory from '../composables/useGameMemory'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items = [
  { visible: true, value: 0, color: 'red', name: 'Gato' },
  { visible: true, value: 1, color: 'blue', name: 'Cuei' },
  { visible: true, value: 2, color: 'pink', name: 'Largato' },
  { visible: true, value: 4, color: 'yellow', name: 'Purga' },
  { visible: true, value: 5, color: 'green', name: 'Vestruis' },
  { visible: true, value: 6, color: 'orange', name: 'Anta' },
  { visible: true, value: 7, color: 'indigo', name: 'Lefante' },
  { visible: true, value: 8, color: 'purple', name: 'Lião' }
]
items.length = 3
const { info, cards, step, chooseCard, startGame, elapsedFullTime } =
  useGameMemory(5, items)

const handleClick = () => {
  startGame()
}

return (_ctx: any,_cache: any) => {
  const _component_app_btn = _resolveComponent("app-btn")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_app_btn, { onClick: handleClick }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(info).status ? 'Reiniciar' : 'Começar'), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (card, key) => {
        return (_openBlock(), _createBlock(_component_app_card, {
          color: card.visible ? card.color : 'white',
          disabled: card.visible || _unref(step) === 3,
          onClick: _withModifiers(($event: any) => (_unref(chooseCard)(key)), ["prevent"]),
          class: "pa-1 ma-1",
          width: "15vw",
          height: "20vw",
          maxWidth: "150px",
          maxHeight: "200px",
          minWidth: "100px",
          minHeight: "150px",
          key: card.value + key
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(card.visible ? card.name : ''), 1)
          ]),
          _: 2
        }, 1032, ["color", "disabled", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", null, _toDisplayString(_unref(elapsedFullTime)), 1),
    (_unref(info).moves > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(`${_unref(info).moves} movimentos, sendo ${_unref(info).matches} acertos e ${_unref(info).errors} erros.`) + " ", 1),
          (_unref(info).matches === _unref(cards).length / 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_app_btn, { onClick: handleClick }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, _toDisplayString(_unref(info)), 1)
  ], 64))
}
}

})